import { Component, computed, inject, input } from '@angular/core';
import { ActionSheetButton, ActionSheetController, IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DemarrerOtService } from '../../../../mnt/ot/demarrer-ot.service';
import { ActiviteEnCours } from '../activite-en-cours.service';
import { ChronoActivite } from '../../../providers/chrono-activite/chrono-activite.model';
import { NgClass } from '@angular/common';
import { DemarrerActiviteInterneService } from '../../../providers/activite-interne/demarrer-activite-interne.service';

@Component({
  selector: 'bandeau-activite',
  templateUrl: 'bandeau-activite.component.html',
  styleUrls: ['./bandeau-activite.component.scss'],
  standalone: true,
  imports: [IonicModule, TranslateModule, NgClass],
})
export class BandeauActiviteComponent {
  private router: Router = inject(Router);
  private demarrerOtService: DemarrerOtService = inject(DemarrerOtService);
  private demarrerActiviteInterneService: DemarrerActiviteInterneService = inject(DemarrerActiviteInterneService);
  private translate: TranslateService = inject(TranslateService);
  private actionSheetController: ActionSheetController = inject(ActionSheetController);

  activiteEncours = input.required<ActiviteEnCours>();
  chronoEnCours = input<ChronoActivite>();

  etatActivite = computed(() => {
    if (this.chronoEnCours() && this.chronoEnCours().idActivite === this.activiteEncours().id) {
      if (this.activiteEncours().type === 'ot') {
        return this.chronoEnCours().horodatageEncours.statutActivite;
      } else {
        return 'En cours';
      }
    }
    return '';
  });

  async clickActivite() {
    if (this.activiteEncours().type === 'ot') {
      await this.router.navigate(['/mnt/ots/', this.activiteEncours().id], {});
    } else {
      await this.demarrerActiviteInterneService.redirectToActiviteInternePage(this.activiteEncours().id);
    }
  }

  async onMoreClick() {
    const buttons: ActionSheetButton[] = [];
    if (this.activiteEncours().id_sti) {
      buttons.push({
        text: this.translate.instant('CHRONO.STI.DETAIL'),
        handler: async () => {
          await this.router.navigate(['/mnt/stis/', this.activiteEncours().id_sti, 'details'], {
            queryParams: {
              idSti: this.activiteEncours().id_sti,
              libelleOt: this.activiteEncours().libelle,
            },
          });
        },
      });
    } else {
      buttons.push({
        text: this.translate.instant('CHRONO.REMOVE_CHRONO'),
        handler: () => {
          const type = this.activiteEncours().type;
          switch (type) {
            case 'ot':
              this.demarrerOtService.stopOT(this.activiteEncours().id);
              break;
            case 'activite-interne':
            case 'renfort':
              this.demarrerActiviteInterneService.stopActiviteInterne(this.activiteEncours().id);
              break;
          }
        },
      });
    }
    if (this.activiteEncours().type === 'ot') {
      buttons.push({
        text: this.translate.instant('CHRONO.PAUSE_CHRONO'),
        handler: () => {
          this.demarrerOtService.mettreAnPauseOt(this.activiteEncours().id);
        },
      });
    }
    buttons.push({
      text: this.translate.instant('GLOBAL.CANCEL'),
      role: 'cancel',
    });

    this.actionSheetController.create({ buttons: buttons }).then((a) => a.present());
  }
}
